import { DollarOutlined } from '@ant-design/icons'
import { Spin, Tabs } from 'antd'
import _ from 'lodash'
import { ReportAffiliateType } from 'Modules'
import { LabelValues } from 'Modules'
import { useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { LEVEL_LABEL } from 'constants/affiliate'
import { AFFILIATES_TABS, BREADCRUMBS } from 'constants/breadcrumb'
import { TOKEN_LABEL } from 'constants/token'
import AffiliateCommission from 'modules/affiliate-commission'
import ReferralUser from 'modules/referral-user'
import { logError } from 'utils/logger'
import { getLabelToValue } from 'utils/object'

import './style.scss'

export default function Affiliates() {
  const [reportAffiliates, setReportAffiliates] = useState<LabelValues[]>([])
  const [totalClaimed, setTotalClaimed] = useState<any[]>([])
  const [activeTab, setActiveTab] = useState(AFFILIATES_TABS.COMMISSION)
  const [loading] = useState(false)

  const getReport = async () => {
    try {
      const { data } = await AppAdmin.getReferralReport()
      if (data.success) {
        const reportData = data.data.report || ([] as Array<ReportAffiliateType>)
        if (reportData?.length) {
          const reportAffiliates = _.chain(reportData)
            .groupBy('type')
            .map((value, key) => {
              return {
                label: getLabelToValue(TOKEN_LABEL, Number(key)),
                value: key,
                data: _.sortBy(value, 'level'),
              }
            })
            .value()
          setReportAffiliates(reportAffiliates)
        }

        // Process total claimed data from the same response
        const totalClaimedData = data.data.totalClaimed
        if (totalClaimedData) {
          const formattedData = [
            {
              title: 'Total Claimed (MEY)',
              amount: totalClaimedData.totalClaimedMEY,
              usdAmount: totalClaimedData.totalClaimedMEYUsd,
              color: '#28a745',
            },
            {
              title: 'Total Claimed (USDC)',
              amount: totalClaimedData.totalClaimedUSDC,
              usdAmount: totalClaimedData.totalClaimedUSDCUsd,
              color: '#007bff',
            },
          ]
          setTotalClaimed(formattedData)
        }
      }
    } catch (error) {
      logError('Error: ', error)
    }
  }

  useEffect(() => {
    getReport()
  }, [])

  const additionalItems = [BREADCRUMBS.AFFILIATES]
  return (
    <>
      <div className="main-section affiliates">
        <Breadcrumb additionalItems={additionalItems} />
        <div className="main-title" style={{ marginBottom: 20 }}>
          Affiliates
        </div>

        <div className="dashboard-container">
          <div className="wrap-dashboard">
            <div className="wrap-box">
              <div className="wrap-columns">
                <div className="columns" style={{ display: 'flex', gap: '20px' }}>
                  {totalClaimed.map((item, index) => (
                    <div key={index} className="colum" style={{ flex: 1 }}>
                      <div className="guide-box">
                        <div className="box-content">
                          <div className="left-s">
                            <div className="txt">
                              {item.title}
                              <div className="number" style={{ color: item.color }}>
                                {new Intl.NumberFormat('en-US').format(item.amount)}
                              </div>
                              <div
                                className="number"
                                style={{ color: '#6c757d', fontSize: '14px' }}
                              >
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(item.usdAmount)}
                              </div>
                            </div>
                          </div>
                          <div className="right-s">
                            <div className="icon" style={{ color: item.color }}>
                              <DollarOutlined />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-container">
          <div className="wrap-dashboard">
            <div className="wrap-box">
              {reportAffiliates.map((reportAffiliate, index: number) => {
                return (
                  <div className="wrap-columns" key={index}>
                    <div className="columns">
                      {reportAffiliate.data?.map((item: ReportAffiliateType, key: number) => {
                        return (
                          <div className="colum w-4 w-sm-6" key={key}>
                            <div className="guide-box">
                              <div className="box-content">
                                <div className="left-s">
                                  <div className="txt">
                                    Total Users ({getLabelToValue(LEVEL_LABEL, item.level)})
                                    <div className="number">
                                      {loading ? <Spin /> : item?.totalUsers}
                                    </div>
                                  </div>
                                  <div className="txt">
                                    Total Commission ({reportAffiliate.label})
                                    <div className="number">
                                      {loading ? (
                                        <Spin />
                                      ) : (
                                        new Intl.NumberFormat('en-US').format(item?.totalReward)
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="right-s">
                                  <div className="icon">
                                    <DollarOutlined />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: AFFILIATES_TABS.COMMISSION,
              label: 'Referral Commission',
              children: <AffiliateCommission />,
            },
            {
              key: AFFILIATES_TABS.REFERRAL_USER,
              label: 'Referral User',
              children: <ReferralUser />,
            },
          ]}
        />
      </div>
    </>
  )
}
